import Vue from 'vue'

require("./bootstrap");
require('select2');
// window.Vue = require('vue');

// const app = new Vue({
//   el: '#app',
// });
// Dropzone
window.Dropzone = require("dropzone");
Dropzone.autoDiscover = false;

import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

Vue.component('search-component', require('./components/SearchComponent.vue').default);

const app = new Vue({
  el: '#app'
});

const filter = require("./filter/filter");
const filterList = require("./filter/filter_list");

$(() => {
  $(".cargoDestroy").on("click", e => {

    const modalName = e.currentTarget.dataset.target;
    const cargoId = e.currentTarget.dataset.cargoId;
    $(`${modalName} form`).attr("action", `/cargo/${cargoId}`);
  });

  $("[data-filter]").on("click", function(e) {
    e.preventDefault();
    let filter_id = $(this).attr("data-filter");
    filter.set(filter_id);
  });

  $(".filter-list").on("click", "a", e => {
    e.preventDefault();
    let filter_id = "#filter";
    filter.set(filter_id);
  });

  // select 2
  $('select:not(.pin-select)').select2({
    placeholder: 'No items selected',
    allowClear: true,
    closeOnSelect: true,
    theme: 'bootstrap4',
    width: 'resolve'
  });

  $('select[multiple]').select2({
    placeholder: 'No items selected',
    allowClear: true,
    closeOnSelect: false,
    theme: 'bootstrap4',
    width: 'resolve'
  });

  $('select[multiple].tags').select2({
    tags: true,
    theme: 'bootstrap4',
    placeholder: 'Type supplier and press enter to add',
  });

  $('select#vesselname').select2({
    tags: true,
    theme: 'bootstrap4',
    placeholder: 'Type a vessel and press enter to add',
  });

  $('select#pin').select2({
    tags: true,
    theme: 'bootstrap4',
    placeholder: 'Type a pin number and press enter to add',
  });

  // $('select#consol').select2({
  //   tags: true,
  //   theme: 'bootstrap4',
  //   placeholder: 'Type a consol number and press enter to add',
  // });

  $('select#loadpoint').select2({
    tags: true,
    theme: 'bootstrap4',
    placeholder: 'Type a loadpoint and press enter to add',
  });

  $('select#destination').select2({
    tags: true,
    theme: 'bootstrap4',
    placeholder: 'Type a destination and press enter to add',
  });

  $('[data-toggle="tooltip"]').tooltip();

  $('select[multiple].onerow').on('select2:close', function (evt) {
    var uldiv = $(this).siblings('span.select2').find('ul')
    var count = $(this).select2('data').length
    if(count==0){
      uldiv.html("<li>no items selected</li>")
    }
    else{
      uldiv.html("<li>"+count+" items selected</li>")
    }
  });

  // $('select').on('select2:change', function (evt) {
  //   var uldiv = $(this).siblings('span.select2').find('ul')
  //   var count = $(this).select2('data').length
  //   if(count==0){
  //     uldiv.html("No items selected")
  //   }
  //   else{
  //     uldiv.html("<li>"+count+" items selected</li>")
  //   }
  // });




// $('select').select2({closeOnSelect: false}).on("change", function(e) {
//   $('.select2-selection__rendered li:not(.select2-search--inline)').hide();
//   $('.counter').remove();
//   var counter = $(".select2-selection__choice").length;
//   $('.select2-selection__rendered').after('<div style="line-height: 28px; padding: 5px;" class="counter">'+counter+' selected</div>');
// });
  // ---- Datepicker ---- //
  // $(".date").datepicker();
});

filterList.set();
